export default __webpack_public_path__ + "static/Kids-fashion-day-74199801ffbe8c78ed6f0c7c05c2284e.png";